import "/root/workspace/ubq-h5_build/node_modules/core-js/modules/es.array.iterator.js";
import "/root/workspace/ubq-h5_build/node_modules/core-js/modules/es.promise.js";
import "/root/workspace/ubq-h5_build/node_modules/core-js/modules/es.object.assign.js";
import "/root/workspace/ubq-h5_build/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'; // 按需引入组件

import '@/core/lazy_use'; // 全局样式

import '@/assets/css/common.scss'; // 过滤器

import '@/filters';
Vue.config.productionTip = false;

if (process.env.VUE_APP_ENV !== 'production') {
  Vue.config.devtools = true;
}

new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');